import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import FieldLabel from '../components/FieldLabel';
import { getFieldLabel } from '../utils/formHelpers';
import { outlinedFieldProps } from '../utils/fieldStyles';
import { CONTINENTS } from '../../../../../data/continentCountries';

const ContinentField = ({ field, data, change, hasError, errorMessage }) => (
    <Autocomplete
        size="small"
        options={CONTINENTS}
        value={data[field.key] || null}
        onChange={(_, newValue) => change(field.key, newValue || '')}
        renderInput={(params) => (
            <TextField
                {...params}
                {...outlinedFieldProps}
                label={<FieldLabel label={getFieldLabel(field)} tooltip={field.tooltip} />}
                placeholder="Select continent"
                error={hasError}
                helperText={hasError ? (errorMessage || 'This field is required') : ''}
            />
        )}
    />
);

export default ContinentField;
